import { Toaster, toast as sonnerToast } from "sonner";

// ── Provider: drops the Toaster into the tree ──
export const ToastProvider = ({ children }) => (
  <>
    {children}
    <Toaster
      position="top-right"
      richColors
      closeButton
      duration={4000}
      expand={false}
      gap={10}
      offset={20}
      visibleToasts={4}
      toastOptions={{
        style: {
          fontFamily: "Poppins, sans-serif",
          fontSize: "0.85rem",
        },
      }}
    />
  </>
);

// ── Hook: returns a toast API matching the previous interface ──
const normalize = (msg) => (msg == null ? "" : String(msg));

const buildOptions = (opts) => {
  if (!opts || typeof opts !== "object") return undefined;
  const { description, duration, ...rest } = opts;
  const result = { ...rest };
  if (description != null) result.description = description;
  if (duration != null) result.duration = duration;
  return result;
};

const show = (type, message, options) => {
  const msg = normalize(message);
  const opts = buildOptions(options);
  switch (type) {
    case "success":
      return sonnerToast.success(msg, opts);
    case "error":
      return sonnerToast.error(msg, opts);
    case "warning":
      return sonnerToast.warning(msg, opts);
    case "info":
      return sonnerToast.info(msg, opts);
    default:
      return sonnerToast(msg, opts);
  }
};

const toastApi = {
  show,
  success: (msg, opts) => sonnerToast.success(normalize(msg), buildOptions(opts)),
  error: (msg, opts) => sonnerToast.error(normalize(msg), buildOptions(opts)),
  warning: (msg, opts) => sonnerToast.warning(normalize(msg), buildOptions(opts)),
  info: (msg, opts) => sonnerToast.info(normalize(msg), buildOptions(opts)),
  dismiss: (id) => sonnerToast.dismiss(id),
};

export const useToast = () => toastApi;
